/** Telegram hard-caps a text message at 4096 characters; the composer shows a
 *  counter as you approach it and refuses to send past it (the server would
 *  reject with MESSAGE_TOO_LONG anyway). */
export const TG_MAX_CHARS = 4096;
const COUNTER_THRESHOLD = 3500;

export function charCounter(len: number): string | null {
  return len < COUNTER_THRESHOLD ? null : `${len} / ${TG_MAX_CHARS}`;
}

export function overCharLimit(len: number): boolean {
  return len > TG_MAX_CHARS;
}

/** Telegram rejects files over 2 GiB outright; browser MTProto uploads of
 *  merely-big files succeed but are slow enough to warn about. */
const MAX_UPLOAD_BYTES = 2 * 1024 ** 3;
const SLOW_UPLOAD_BYTES = 50 * 1024 ** 2;

export function attachmentIssue(bytes: number): "too_big" | "slow" | null {
  if (bytes > MAX_UPLOAD_BYTES) return "too_big";
  if (bytes > SLOW_UPLOAD_BYTES) return "slow";
  return null;
}
